import { useLingui } from "@lingui/react/macro";
import { Text } from "@offstreetparking/design-system/typography";
import { DateTime } from "luxon";
import type { WizardParkingChoice } from "../../../../PermitContextProvider/types";

const displayDate = ({ value, locale }: { value: DateTime; locale: string }) =>
	value.toFormat("LLL d, yyyy", { locale });
const displayTime = ({ value, locale }: { value: DateTime; locale: string }) => value.toFormat("h:mm a", { locale });
const parseDate = (value: string) => DateTime.fromFormat(value, "yyyy-MM-dd");
const parseTime = (value: string) => DateTime.fromFormat(value, "HH:mm:ss");

export const StartTimeHelper = ({
	wizardSettings,
}: {
	wizardSettings: WizardParkingChoice["time"];
}) => {
	const { i18n, t } = useLingui();
	if (!wizardSettings.timeNotInPast && wizardSettings.startDate.min && wizardSettings.startDate.max === undefined) {
		return (
			<div className="mb-4 rounded-lg bg-neutral-faded p-2">
				<Text size="sm" weight="medium">
					{wizardSettings.startTime.min
						? t`Must be after ${displayDate({ value: parseDate(wizardSettings.startDate.min), locale: i18n.locale })} and after ${displayTime({ value: parseTime(wizardSettings.startTime.min).minus({ minutes: 1 }), locale: i18n.locale })}`
						: wizardSettings.startTime.max
							? t`Must be after ${displayDate({ value: parseDate(wizardSettings.startDate.min), locale: i18n.locale })} and before ${displayTime({ value: parseTime(wizardSettings.startTime.max), locale: i18n.locale })}`
							: t`Must be after ${displayDate({ value: parseDate(wizardSettings.startDate.min), locale: i18n.locale })}`}
				</Text>
			</div>
		);
	}
	if (wizardSettings.startDate.max && wizardSettings.startDate.min === undefined) {
		return (
			<div className="mb-4 rounded-lg bg-neutral-faded p-2">
				<Text size="sm" weight="medium">
					{wizardSettings.startTime.max
						? t`Must be before ${displayDate({ value: parseDate(wizardSettings.startDate.max).plus({ days: 1 }), locale: i18n.locale })} and before ${displayTime({ value: parseTime(wizardSettings.startTime.max).plus({ minutes: 1 }), locale: i18n.locale })}`
						: wizardSettings.startTime.min
							? t`Must be before ${displayDate({ value: parseDate(wizardSettings.startDate.max).plus({ days: 1 }), locale: i18n.locale })} and after ${displayTime({ value: parseTime(wizardSettings.startTime.min), locale: i18n.locale })}`
							: t`Must be before ${displayDate({ value: parseDate(wizardSettings.startDate.max).plus({ days: 1 }), locale: i18n.locale })}`}
				</Text>
			</div>
		);
	}
	if (!wizardSettings.timeNotInPast && wizardSettings.startTime.min && wizardSettings.startTime.max === undefined) {
		return (
			<div className="mb-4 rounded-lg bg-neutral-faded p-2">
				<Text size="sm" weight="medium">
					{t`Must be after ${displayTime({ value: parseTime(wizardSettings.startTime.min).minus({ minutes: 1 }), locale: i18n.locale })}`}
				</Text>
			</div>
		);
	}
	if (wizardSettings.startTime.max && wizardSettings.startTime.min === undefined) {
		return (
			<div className="mb-4 rounded-lg bg-neutral-faded p-2">
				<Text size="sm" weight="medium">
					{t`Must be before ${displayTime({ value: parseTime(wizardSettings.startTime.max).plus({ minutes: 1 }), locale: i18n.locale })}`}
				</Text>
			</div>
		);
	}
	return null;
};
